import Portal from 'components/modal/Portal'

import PropTypes from 'prop-types'
import { AlertCircle, Info, XCircle, CheckCircle, HelpCircle } from 'react-feather'
import { Button, ModalBody, Modal, ModalHeader, ModalFooter } from 'reactstrap'
import { useTranslation } from 'react-i18next'

export const MODAL_ICONS = {
  alert: AlertCircle,
  info: Info,
  error: XCircle,
  success: CheckCircle,
  help: HelpCircle,
}

//sizes : xs,sm,md,lg,xl

export const GenericModal = ({
  show = false,
  title = 'Atenció',
  acceptCb,
  closeCb,
  backCb,
  cancelCb,
  children,
  size,
  isConfirm = false,
  positiveColor = 'primary',
  negativeColor = 'secondary',
  txBtnPositive = '',
}) => {
  GenericModal.propTypes = {
    show: PropTypes.bool,
    size: PropTypes.string,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.node]),
    acceptCb: PropTypes.func,
    backCb: PropTypes.func,
    cancelCb: PropTypes.func,
    closeCb: PropTypes.func,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
    isConfirm: PropTypes.bool,
    positiveColor: PropTypes.string,
    negativeColor: PropTypes.string,
    txBtnPositive: PropTypes.string,
  }

  const { t } = useTranslation('common')

  const header = title ? (
    typeof title === 'string' ? (
      <ModalHeader> {title}</ModalHeader>
    ) : (
      title
    )
  ) : null

  const txtPositive =
    txBtnPositive !== '' ? txBtnPositive : isConfirm ? t('buttons.confirm') : t('buttons.accept')

  return (
    <Portal>
      <Modal isOpen={show} centered size={size}>
        {header}
        <ModalBody>{children}</ModalBody>
        {acceptCb || cancelCb || closeCb ? (
          <ModalFooter>
            {backCb ? (
              <Button onClick={backCb} color={negativeColor}>
                {t('buttons.back')}
              </Button>
            ) : null}

            {acceptCb ? (
              <Button
                color={positiveColor}
                onClick={() => {
                  acceptCb()
                }}
              >
                {txtPositive}
              </Button>
            ) : null}

            {cancelCb ? (
              <Button
                color={negativeColor}
                onClick={(evt) => {
                  evt.preventDefault()
                  cancelCb()
                }}
              >
                {t('buttons.cancel')}
              </Button>
            ) : null}
            {closeCb ? (
              <Button
                color={negativeColor}
                onClick={(evt) => {
                  evt.preventDefault()
                  closeCb()
                }}
              >
                {t('buttons.close')}
              </Button>
            ) : null}
          </ModalFooter>
        ) : null}
      </Modal>
    </Portal>
  )
}
